import { FooterDrawer, useDiagnosticCard } from '@common/Footer/IDEFooterDrawer';
import { ReactNode } from 'react';

import { Log } from '../../../generic-components/Logger/types';

export function Footer({ renderLogLabel }: { renderLogLabel: (log: Log) => ReactNode }) {
  const diagnosticCard = useDiagnosticCard({ renderLogLabel, showRunTimeTab: false });
  const cards = [diagnosticCard];
  return <FooterDrawer gitEnabled={true} cards={cards} />;
}
